import React, { useState } from "react";
import axios from "axios";
import GoogleSocial from "./Google & facebook/GoogleSocial";
import LoginGoogleSocial from "./Google & facebook/LoginGoogle";
import FacebookLogin from "./Google & facebook/FacebookLogin";
import { useNavigate,Navigate } from "react-router-dom";
import {
  useToast,
  InputGroup,
  Input,
  InputRightElement,
  Button,
} from "@chakra-ui/react";
import { useCookies } from "react-cookie";
import ReactLoading from "react-loading";
import API_URL from "../Api/auction-api";

const Login = ({ change, conditiontomove }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cookies, setCookie] = useCookies();
  const [isloading, setLoading] = useState(false);
  const [loginClick, setLoginClick] = useState(false);
  const [passView, setView] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

//   Password hide and show 
  const handleView = () => {
    console.log(passView, "passview");
    setView(!passView); // to see the password
  };

  // This function is handle the login 

  async function handleLogin() {
    const payload = {   
      email,
      password,
    };
    try {
     
      if (email && password) {
        setLoading(true);
        if(password==="malaktel@1234"){
          let adminRes=await axios.post(`${API_URL}/getadmindata`,{email})
        console.log(adminRes.data,"adminres")
        if(adminRes.data=="This user is admin"){
          setCookie("email", email);
          setCookie("password",password)
          setCookie("adminstatus","admin")
          console.log("admin")
          // window.location.href="/participate"
          // setLoading(false);
          toast({
            title: "Admin login successfully",
            description:"Now Your a Admin of this site ",
            status: "success",
            duration: 9000,
            isClosable: true,
            position: "top-right",
          });
            navigate("/participate")

        }
        
        }else{
        let res = await axios.post(`${API_URL}/login`, payload);  // post the login details 
        console.log(res.data, "respose");
        setCookie("email", email);
        setCookie("password",password)
        setCookie("adminstatus","user")
        toast({
          title: "Login  successfully.",
          status: "success",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
        setLoading(false);
        navigate("/participate");// naviagte to participate page
        }  
      } else {
        toast.error("Fill All  Details.")
        toast({
          title: "Fill All  Details.",
          description:"Required to fill all the details",
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
        setLoading(false);
      }

      // if(res.data=="login done"){
      //   conditiontomove(true)

      // }
    } catch (error) {
      
      toast({
        title: "Login failed !",
        description: "please check email or password",
        status: "error",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
      setLoading(false);
      console.log(error);
    }
  }

  if (loginClick) {
    return (
      <div
        style={{
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "var(--background)",
        }}
      >
        <ReactLoading
          type={"bubbles"}
          color={"var(--background2)"}
          height={"10%"}
          width={"10%"}
        />
      </div>
    );
  }

  return (
    <>
      {isloading ? (
        <div
          style={{
            height: "80vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "var(--background)",
          }}
        >
          <ReactLoading
            type={"bubbles"}
            color={"var(--background2)"}
            height={"10%"}
            width={"10%"}
          />
        </div>
      ) : (
        <div name="login">
          <section class="h-screen">
            <div class="h-full">
              {/* <!-- Left column container with background--> */}
              <div class="g-6 flex h-full flex-wrap items-center justify-center lg:justify-between">
                <div class="shrink-1 mb-12 grow-0 basis-auto md:mb-0 md:w-9/12 md:shrink-0 lg:w-6/12 xl:w-6/12">
                  <img
                    src="https://img.freepik.com/free-vector/forgot-password-concept-illustration_114360-1123.jpg?w=740&t=st=1685599736~exp=1685600336~hmac=70ede9b809a0da3d2ecf9f4a0ba5e44c29fc0e2d2e668d42aa0133e6220a5553"
                    class="w-full"
                    alt="Sample image"
                  />
                </div>

                {/* <!-- Right column container --> */}
                <div class="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">
                  <h2 className="flex flex-col justify-center items-center text-3xl mb-5 font-bold font-serif">
                    log in
                  </h2>
                  <form
                    style={{ marginRight: "20px" }}
                    onSubmit={(e) => e.preventDefault()}
                  >
                    {/* <!--Sign in section--> */}
                    <div class="flex flex-row items-center justify-center lg:justify-start">
                      <p class="mb-0 mr-4 text-lg">Login with</p>
                      {/* <!-- Linkedin --> */}

                      <LoginGoogleSocial logincheck={setLoginClick} />
                      {/* <FacebookLogin/> */}
                    </div>

                    {/* <!-- Separator between social media sign in and email/password sign in --> */}
                    <div class="my-4 flex items-center before:mt-0.5 before:flex-1 before:border-t before:border-neutral-300 after:mt-0.5 after:flex-1 after:border-t after:border-neutral-300">
                      <p class="mx-4 mb-0 text-center font-semibold dark:text-white">
                        Or
                      </p>
                    </div>

                    {/* <!-- Email input --> */}
                    <div class="relative mb-6" data-te-input-wrapper-init>
                      <label
                        for="Email"
                        class="block text-sm font-medium text-gray-700"
                      >
                        Email address
                      </label>

                      <input
                        type="email"
                        id="Email"
                        name="email"
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        class="mt-1 w-full p-2 rounded-md border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                      />
                    </div>

                    {/* <!-- Password input --> */}
                    <div class="relative mb-6" data-te-input-wrapper-init>
                      <label
                        for="Password"
                        class="block text-sm font-medium text-gray-700"
                      >
                        Password
                      </label>
                      <InputGroup size="md">
                        <input
                          type={passView ? "text" : "password"}
                          id="Password"
                          name="password"
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          class="mt-1 w-full p-2 rounded-md border border-gray-500 bg-white text-sm text-gray-700 shadow-sm"
                        />

                        <InputRightElement width="4.5rem">
                          <Button
                            background="none"
                            h="15px"
                            mt="8px"
                            _hover={{ background: "none" }}
                            onClick={handleView}
                          >
                            {passView ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                              >
                                <path d="M19.604 2.562l-3.346 3.137c-1.27-.428-2.686-.699-4.243-.699-7.569 0-12.015 6.551-12.015 6.551s1.928 2.951 5.146 5.138l-2.911 2.909 1.414 1.414 17.37-17.035-1.415-1.415zm-6.016 5.779c-3.288-1.453-6.681 1.908-5.265 5.206l-1.726 1.707c-1.814-1.16-3.225-2.65-4.06-3.66 1.493-1.648 4.817-4.594 9.478-4.594.927 0 1.796.119 2.61.315l-1.037 1.026zm-2.883 7.431l5.09-4.993c1.017 3.111-2.003 6.067-5.09 4.993zm13.295-4.221s-4.252 7.449-11.985 7.449c-1.379 0-2.662-.291-3.851-.737l1.614-1.583c.715.193 1.458.32 2.237.32 4.791 0 8.104-3.527 9.504-5.364-.729-.822-1.956-1.99-3.587-2.952l1.489-1.46c2.982 1.9 4.579 4.327 4.579 4.327z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                              >
                                <path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z" />
                              </svg>
                            )}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                    </div>

                    <div class="mb-6 flex items-center justify-between">
                      {/* <!--Forgot password link--> */}
                      <a href="/forgetpassword">Forgot password?</a>
                    </div>

                    {/* <!-- Login button --> */}
                    <div class="text-center lg:text-left">
                      <button
                        type="submit"
                        class="inline-block rounded bg-primary px-7 pb-2.5 pt-3 text-sm font-medium uppercase leading-normal text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                        data-te-ripple-init
                        data-te-ripple-color="light"
                        onClick={handleLogin}
                      >
                        Login
                      </button>

                      {/* <!-- Register link --> */}
                      <p class="mb-0 mt-2 pt-1 text-sm font-semibold">
                        Don't have an account?
                        <a
                          href="/signup"
                          style={{ cursor: "pointer" }}
                          class="text-danger underline text-sm font-bold ml-2 transition duration-150 ease-in-out"
                        >
                          Sign up
                        </a>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default Login;
